import { render, staticRenderFns } from "./identification.vue?vue&type=template&id=d9cae56c&scoped=true&"
import script from "./identification.vue?vue&type=script&lang=js&"
export * from "./identification.vue?vue&type=script&lang=js&"
import style0 from "./identification.vue?vue&type=style&index=0&id=d9cae56c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cae56c",
  null
  
)

export default component.exports